module.exports = __webpack_public_path__ + "img/banner3_1.28c4886f.png";